import AvatarIcon from './components/images/AvatarIcon'

export default function () {
  return { component: AvatarIcon }
}
